export interface PageHeaderTextProps {
  text: string;
}

const PageHeaderText = (props: PageHeaderTextProps) => {
  return <p className="text-3xl text-primaryBlue font-bold">{props.text}</p>;
};

export default PageHeaderText;
